'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiCode = function TiCode(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm13.6 30c-0.8 0-1.7-0.3-2.3-1l-7.4-7.3 7.4-7.4c1.3-1.3 3.4-1.3 4.7 0 1.3 1.3 1.3 3.4 0 4.7l-2.7 2.7 2.7 2.6c1.3 1.3 1.3 3.4 0 4.7-0.7 0.7-1.5 1-2.4 1z m12.8 0c-0.9 0-1.7-0.3-2.4-1-1.3-1.3-1.3-3.4 0-4.7l2.7-2.6-2.7-2.7c-1.3-1.3-1.3-3.4 0-4.7 1.3-1.3 3.4-1.3 4.7 0l7.4 7.4-7.4 7.3c-0.6 0.7-1.5 1-2.3 1z' })
        )
    );
};

exports.default = TiCode;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/code.js
// module id = 3589
// module chunks = 0